import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { router } from 'constant/router';
import { useHistory } from 'react-router';
import { useRecoilValue } from 'recoil';
import { authenInfoAtom } from 'store/atom-state/authen-atom';

interface IPrivateRoute {
  path?: string;
  component?: any;
  children?: any;
  exact?: boolean;
  roles?: String[];
}

export default function PrivateRoute({
  component: Component,
  roles,
  ...rest
}: IPrivateRoute) {
  const authenInfo = useRecoilValue(authenInfoAtom);
  const isLoggedIn = authenInfo?.isLoggedIn;
  const currentUser = authenInfo?.currentUser;
  const history = useHistory();
  const permissionRoute = !roles || (roles || []).includes(currentUser?.userTp);
  if (!isLoggedIn) {
    history.push(router.login);
    return null;
  }
  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (permissionRoute) return <Component />;
        return (
          <Redirect
            to={{
              pathname: router.not_found_page,
              // state: { from: location },
            }}
          />
        );
      }}
    />
  );
}
